const Downwards = () => '\u2193';

export default Downwards;
